import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-popup',
  standalone: false,
  templateUrl: './delete-popup.html',
  styleUrl: './delete-popup.scss'
})
export class DeletePopup {

  action: string;
  name:string;
  type:string;
  permanent:boolean ;
  warning?: string;

  constructor(
    private readonly dialogRef: MatDialogRef<DeletePopup>,
    @Inject(MAT_DIALOG_DATA) public data: { action: string, type: string, permanent: boolean, warning?: string }) {
    this.action = data.action;
    this.type = data.type;
    this.permanent = data.permanent;
    this.warning = data.warning;
  }

  close() {
    this.dialogRef.close(false);
  }

  confirmDelete() {
    this.dialogRef.close(true);
  }
}